// Testing API functions

import type { TestResult, TestFormData } from './testing.schema';
import { apiFetch } from '../../shared/api/apiClient';

/**
 * Execute an API test request.
 * body is already a raw JSON string from the textarea — pass it directly,
 * do NOT JSON.stringify() it again (that would double-serialise the payload).
 */
export async function executeTest(testData: TestFormData): Promise<TestResult> {
  try {
    const response = await apiFetch(testData.endpoint, {
      method: testData.method,
      headers: {
        'Content-Type': 'application/json',
        ...testData.headers,
      },
      body: testData.method !== 'GET' && testData.method !== 'DELETE' ? testData.body : undefined, // pass raw string; body is already valid JSON text
    });

    return {
      success: response.status >= 200 && response.status < 300,
      status: response.status,
      data: response.data,
      timestamp: Date.now(),
    };
  } catch (error) {
    return {
      success: false,
      status: 0,
      data: null,
      error: error instanceof Error ? error.message : 'Unknown error',
      timestamp: Date.now(),
    };
  }
}
